import React, { useCallback, useEffect, useState } from "react";
import { Col, Input, Row, Table, Spinner } from "reactstrap";
import { formatNumber } from "../helper";
import { fetchData, _fetchApi } from "./api";

export default function NewAverage({
  year_from,
  year_to,
  indicator,
  setForm,
  new_indicator,
  data_source,
  uemoa,
}) {
  const [data, setData] = useState([]);
  const [ppp, setppp] = useState([]);
  const [indicatorWorld, setIndicatorWorld] = useState([]);
  const [indicatorAfrc, setIndicatorAfrc] = useState([]);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    setLoading(true);
    fetchData({
      query_type: "get_indicators",
      type_of_data: "World Economic Outlook",
    })
      .then((d) => {
        if (d && d.results) {
          setIndicatorWorld([
            // 'Regional Indicator',
            ...d.results.map((a) => a.indicator),
          ]);
          setLoading(false);
        }
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  }, []);

  React.useEffect(() => {
    setLoading(true);
    fetchData({
      query_type: "get_indicators",
      type_of_data: "Sub-Saharan Africa Regional Economic Outlook?(AFRREO)",
    })
      .then((d) => {
        if (d && d.results) {
          setIndicatorAfrc([...d.results.map((a) => a.indicator)]);
          setLoading(false);
        }
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  }, []);

  // const get_by_ppp = useCallback(() => {
  //   _fetchApi(
  //     `/get_by_indicator?query_type=get_ppp&year_from=${year_from}&year_to=${year_to}&indicator=${indicator}&new_indicator=${new_indicator}`,
  //     (d) => {
  //       setppp(d.results);
  //       console.log(d);
  //     },
  //     (err) => {
  //       console.log(err);
  //     }
  //   );
  // }, [year_from, year_to, indicator, new_indicator]);

  // const get_by_Average = useCallback(() => {
  //   _fetchApi(
  //     `/get_by_indicator?query_type=new_average&year_from=${year_from}&year_to=${year_to}&indicator=${indicator}`,
  //     (d) => {
  //       // let element = "";
  //       // for (let index = 0; index < ppp.length; index++) {
  //       //   element += ppp[index].ppp;
  //       // }
  //       setData(d.results);
  //       // console.log(element, "LLLL");
  //     },
  //     (err) => {
  //       console.log(err);
  //     }
  //   );
  // }, [year_from, year_to, indicator]);

  // useEffect(() => {
  //   get_by_ppp();
  //   get_by_Average();
  // }, [get_by_ppp, get_by_Average]);

  useEffect(() => {
    setLoading(true);
    _fetchApi(
      `/countrywise?query_type=&year_from=${year_from}&year_to=${year_to}&new_indicator=${indicator}&indicator=${new_indicator}&type_of_data=Sub-Saharan Africa Regional Economic Outlook?(AFRREO)&data_source=${data_source}&uemoa=${uemoa}`,
      (d) => {
        // let element = "";
        // for (let index = 0; index < ppp.length; index++) {
        //   element += ppp[index].ppp;
        // }
        setData(d.results);
        setLoading(false);
        // console.log(element, "LLLL");
      },
      (err) => {
        console.log(err);
        setLoading(false);
      }
    );
  }, [year_from, year_to, indicator, new_indicator, data_source, uemoa]);

  // const newArr = [];
  // data.forEach((i) => {
  //   const select = ppp && ppp.filter((o) => i.country === o.country);

  //   newArr.push({ ...i, ppp: select[0]?.ppp });
  // });

  // const totalP = newArr.reduce((a, b) => a + b.pct, 0);
  // const totalAvg = newArr.reduce((a, b) => a + parseFloat(b.pct * b.ppp), 0);

  return (
    <div
      style={{ height: "80vh", overflow: "auto", marginTop: "2%" }}
      className="card card-body"
    >
      {loading && (
        <div>
          <Spinner /> Loading...
        </div>
      )}
      <Row>
        <Col md={6}>
          <label>Select Sub-Saharan Africa</label>
          <Input
            type="select"
            value={indicator}
            name="indicator"
            onChange={({ target: { value } }) =>
              setForm((p) => ({ ...p, indicator: [value] }))
            }
          >
            <option>--select--</option>
            {indicatorAfrc.map((indicator, id) => (
              <option key={id} value={indicator}>
                {indicator}
              </option>
            ))}
          </Input>
        </Col>
        <Col md={6}>
          <label>Select World</label>
          <Input
            type="select"
            value={new_indicator}
            name="new_indicator"
            onChange={({ target: { value } }) =>
              setForm((p) => ({ ...p, new_indicator: [value] }))
            }
          >
            <option>--select--</option>
            {indicatorWorld.map((indicator, id) => (
              <option key={id} value={indicator}>
                {indicator}
              </option>
            ))}
          </Input>
        </Col>
      </Row>
      {/* {JSON.stringify({ new_indicator, indicator })} */}
      <Table bordered striped style={{ marginTop: 10 }}>
        <thead>
          <tr>
            <th>Country</th>
            <th>GDP</th>
            <th>
              Ratio
              {/* Percentage */}
            </th>
            <th>
              Average
              {/* PPP */}
            </th>
            <th>Weighted Avg.</th>
          </tr>
        </thead>
        <tbody>
          {data.map((d, i) => (
            <tr key={i}>
              <td style={{ cursor: "pointer" }}>{d.country}</td>
              <td className="text-end">{((0 * 100) / 100).toFixed(5)}</td>
              {/* <td>{form.country.includes('Regional Outlook') ? d.country : d.indicator}</td> */}
              <td className="text-end">
                {((d.ratio * 100) / 100).toFixed(5)}
                {/* {(((d.pct * 100) / 100).toFixed(5))} */}
              </td>
              <td className="text-end">
                {((d.average * 100) / 100).toFixed(5)}
                {/* {(((d.ppp * 100) / 100).toFixed(5))} */}
              </td>
              <td className="text-end">
                {((d.multiply * 100) / 100).toFixed(5)}
                {/* {((d.pct * d.ppp * 100) / 100).toFixed(4)} */}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
